import { Col } from "antd";
import styled from "styled-components";

export const MainContainer = styled.div`
  margin-bottom: 2rem;

  .ant-card {
    border-radius: 0.625rem;

    border-color: transparent;
    background: ${({ theme }) => theme.colors.modalBackgroundColor};
  }

  .ant-card-head {
    border-color: ${({ theme }) => theme.colors.backgroundColor};
  }

  .section-title {
    margin-right: 1rem;
  }

  .ant-card-head-title {
    padding: 1rem 0;
    font-size: 1.25rem;
    font-weight: 400;

    color: ${({ theme }) => theme.colors.textColor};
  }

  sup {
    box-shadow: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .link {
    h1,
    div.author-bio span {
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  .gamification-level-medal {
    color: ${({ theme }) => theme.colors.primary};
  }

  .link {
    width: 100%;
    justify-content: center;
    display: flex;
  }

  &.gx-testimonial {
    margin-bottom: 1.25rem;
  }

  .badges-container {
    display: flex;
    justify-content: center;

    img {
      width: 1.625rem;
      height: 1.625rem;
    }

    img:not(:first-child) {
      margin-left: 0.5rem;
    }
  }
`;

export const ColInfoUser = styled(Col)`
  display: -webkit-box;
  text-overflow: ellipsis;
  min-width: 100%;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  .author-bio {
    color: #262626;
    display: flex;
    justify-content: center;

    span {
      text-align: center;
      color: ${({ theme }) => theme.colors.textColor};
    }
  }
`;
